<script setup>
defineProps({
  usersError: { type: String, default: '' },
  operationMessage: { type: String, default: '' },
  operationError: { type: String, default: '' },
  contextReadOnlyMessage: { type: String, default: '' },
})
</script>

<template>
  <div class="users-lifecycle-warnings">
    <p v-if="usersError" class="error">{{ usersError }}</p>
    <p v-if="operationMessage" class="success">{{ operationMessage }}</p>
    <p v-if="operationError" class="error">{{ operationError }}</p>
    <p v-if="contextReadOnlyMessage" class="warning">{{ contextReadOnlyMessage }}</p>
  </div>
</template>

<style scoped>
.error { color: #b91c1c; background: #fee2e2; border-radius: 6px; padding: 0.45rem; }
.success { color: #166534; background: #dcfce7; border-radius: 6px; padding: 0.45rem; }
.warning { color: #92400e; background: #fffbeb; border: 1px solid #fde68a; border-radius: 6px; padding: 0.45rem; }
.users-lifecycle-warnings { display: grid; gap: 0.45rem; }
</style>

